/** Builds a floating whole-column ghost for HTML5 dragImage. */
export function setWorkspaceColumnDragImage(
  th: HTMLTableCellElement,
  dataTransfer: DataTransfer
): void {
  const table = th.closest('table');
  if (!table) return;

  const cellIndex = th.cellIndex;
  const width = Math.max(th.getBoundingClientRect().width, 72);
  const ghost = document.createElement('div');
  ghost.setAttribute('data-workspace-column-drag-ghost', 'true');
  ghost.style.cssText = [
    'position: absolute',
    'top: -10000px',
    'left: -10000px',
    `width: ${width}px`,
    'background: #ffffff',
    'border: 1px solid #e7e7ea',
    'border-radius: 8px',
    'box-shadow: 0 14px 34px -14px rgba(29, 45, 61, 0.35)',
    'overflow: hidden',
    'opacity: 0.96',
    'pointer-events: none',
    'z-index: 9999',
  ].join(';');

  const rows = table.querySelectorAll('tr');
  rows.forEach((row, index) => {
    const cell = row.children.item(cellIndex);
    if (!(cell instanceof HTMLElement)) return;
    const clone = cell.cloneNode(true) as HTMLElement;
    clone.removeAttribute('id');
    clone.style.cssText = [
      'display: block',
      `width: ${width}px`,
      'box-sizing: border-box',
      'background: #ffffff',
      index === 0 ? 'background: #f8f8fa; font-weight: 600;' : '',
      'border-bottom: 1px solid #f0f0f2',
      'padding: 8px 12px',
    ]
      .filter(Boolean)
      .join(';');
    ghost.appendChild(clone);
  });

  document.body.appendChild(ghost);
  dataTransfer.setDragImage(ghost, Math.min(width / 2, 40), 16);

  window.setTimeout(() => {
    ghost.remove();
  }, 0);
}
